import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { getUserSettings } from '@/api/apiService'
import { QueryKeys } from '../models/enum'
import { ResponseObject, UseGetReadModel, UserSettingsDto } from '../models/types'

function useGetUserSettingsService(): UseQueryResult<UserSettingsDto, AxiosError<ResponseObject>> {
    return useQuery<UserSettingsDto, AxiosError<ResponseObject>>({
        queryKey: [QueryKeys.UserSettings],
        queryFn: getUserSettings,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    })
}

export function useGetUserSettings(): UseGetReadModel<UserSettingsDto | null> {
    const { isLoading, error, data } = useGetUserSettingsService()

    return {
        isLoading,
        data: data || null,
        error,
        errorMessage: error?.message,
    }
}
